export var RolePermission;
(function (RolePermission) {
    RolePermission["READ"] = "READ";
    RolePermission["CREATE"] = "CREATE";
    RolePermission["UPDATE"] = "UPDATE";
    RolePermission["DELETE"] = "DELETE";
    RolePermission["AGGREGATE"] = "AGGREGATE";
    RolePermission["FIND"] = "FIND";
    RolePermission["SHARE"] = "SHARE";
    RolePermission["UPLOAD_FILES"] = "UPLOAD_FILES";
    RolePermission["DOWNLOAD_FILES"] = "DOWNLOAD_FILES";
})(RolePermission || (RolePermission = {}));
export const ALL_ROLE_PERMISSIONS = Object.values(RolePermission);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUm9sZVBlcm1pc3Npb25zLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2F1dGgvUm9sZVBlcm1pc3Npb25zLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUlBLE1BQU0sQ0FBTixJQUFZLGNBVVg7QUFWRCxXQUFZLGNBQWM7SUFDeEIsK0JBQWEsQ0FBQTtJQUNiLG1DQUFpQixDQUFBO0lBQ2pCLG1DQUFpQixDQUFBO0lBQ2pCLG1DQUFpQixDQUFBO0lBQ2pCLHlDQUF1QixDQUFBO0lBQ3ZCLCtCQUFhLENBQUE7SUFDYixpQ0FBZSxDQUFBO0lBQ2YsK0NBQTZCLENBQUE7SUFDN0IsbURBQWlDLENBQUE7QUFDbkMsQ0FBQyxFQVZXLGNBQWMsS0FBZCxjQUFjLFFBVXpCO0FBRUQsTUFBTSxDQUFDLE1BQU0sb0JBQW9CLEdBQUcsTUFBTSxDQUFDLE1BQU0sQ0FBQyxjQUFjLENBQUMsQ0FBQyJ9